import { render, staticRenderFns } from "./PollMatrixEditor.vue?vue&type=template&id=6c808702&scoped=true"
import script from "./PollMatrixEditor.vue?vue&type=script&lang=js"
export * from "./PollMatrixEditor.vue?vue&type=script&lang=js"
import style0 from "./PollMatrixEditor.vue?vue&type=style&index=0&id=6c808702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c808702",
  null
  
)

export default component.exports